/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkRealEstateType } from '../models/work-real-estate-type';

@Injectable({ providedIn: 'root' })
export class WorkSelfserviceRealEstateTypesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `selfserviceRealestatetypesV2ControllerGetAllActive()` */
  static readonly SelfserviceRealestatetypesV2ControllerGetAllActivePath = '/v2/selfservice/realestatetypes';

  /**
   * Get all active real estate types.
   *
   * Returns all active real estate types for use in the scaffolding calculator
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceRealestatetypesV2ControllerGetAllActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceRealestatetypesV2ControllerGetAllActive$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkRealEstateType>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceRealEstateTypesService.SelfserviceRealestatetypesV2ControllerGetAllActivePath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkRealEstateType>>;
      })
    );
  }

  /**
   * Get all active real estate types.
   *
   * Returns all active real estate types for use in the scaffolding calculator
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceRealestatetypesV2ControllerGetAllActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceRealestatetypesV2ControllerGetAllActive(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkRealEstateType>> {
    return this.selfserviceRealestatetypesV2ControllerGetAllActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkRealEstateType>>): Array<WorkRealEstateType> => r.body)
    );
  }

}
